export const documents = {};

export type DocumentsResources = typeof documents;
